/*
 * @Author: your name
 * @Date: 2021-07-20 16:16:43
 * @LastEditTime: 2021-07-23 16:59:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/service/modules/financeCenter.js
 */
// 财务中心
// import R3 from '@syman/burgeon-r3';

const { network } = R3;
export default {
  /**
   * 赔付单(列表)
   */
  // 列表
  getPayableAdjustmentList: params => network.post('/api/cs/oc/oms/getPayableAdjustmentList', params),
  // 授权
  getAuth: params => $network.post('/p/cs/ac/v1/alipayAccountManage/getAuth', params),
  // 反客审
  cancelAuditPayableAdjustment: params => network.post('/api/cs/oc/oms/cancelAuditPayableAdjustment', params),
  // 客审
  auditPayableAdjustment: params => network.post('/api/cs/oc/oms/auditPayableAdjustment', params),
  // 财审
  fiAuditPayableAdjustment: params => network.post('/api/cs/oc/oms/fiAuditPayableAdjustment', params),
  // 业审
  bizAuditPayableAdjustment: params => network.post('/api/cs/oc/oms/bizAuditPayableAdjustment', params),
  // 确认责任方
  confirmResponsibilityObjtct: params => network.post('/api/cs/oc/oms/confirmResponsibleParty', params), // 确认责任方确定
  /**
   * 赔付单新增/编辑
   */
  // upload2:(params) => network.post('/p/cs/upload2',params),
  // 请求赔付原因
  getCompensationReason: params => network.post('/api/cs/oc/oms/getCompensationReason', params),
  // 计算应付金额
  getCompensate: params => network.post('/api/cs/oc/oms/getCompensate', params),
  // 保存
  savePayableAdjustment: params => network.post('/api/cs/oc/oms/savePayableAdjustment', params),
  //
  getPayableAdjustment: params => network.post('/api/cs/oc/oms/getPayableAdjustment', params),
  // 弹框 下载账单
  triggerVipBill: params => network.post('/p/cs/ac/v1/triggerVipBill', params),
  addSaleDataTask: params => network.post('/api/cs/oc/oms/v1/sap/addSaleDataTask', params),
  // 弹框 生成销售单
  getVendorCodeAndBillNumber: params => network.get('/p/cs/ac/v1/getVendorCodeAndBillNumber', params),
  generateVipSalesOrder: params => network.get('/p/cs/ac/v1/generateVipSalesOrder', params),
  // 支付宝账单原始数据
  triggerAlipayBill: params => network.post('/p/cs/ip/v1/order/download/alipayBillDownload', params, { serviceId: "r3-ipcs" }),
  // 支付宝账单下载
  alipayBillDownload: params => network.post('/p/cs/alipayBillDownload', params),
  // 结算策略详情
  querySettleConfig: params => network.post('/api/cs/ac/querySettleConfig', params),
  // 结算策略保存
  saveSettleConfig: params => network.post('/api/cs/ac/saveSettleConfig', params),
  // 原始账单导入记录-账单导入
  smallPlatformBill: params => network.post('/api/cs/ac/v1/import/platform/bill', params),
  // 支付宝下载账单
  acAlipayBillDownload: params => network.post('/api/cs/ac/alipayBillDownload', params),
  // 调拨费用分摊
  transferFeeAllocate: params => network.post('/api/cs/ac/transferFeeAllocate', params),
  // 重新计算
  reCaculateLogisticsFee: params => network.post('/api/cs/md/reCaculateLogisticsFee', params),
  // 换票
  changeInvoice: params => network.post('/api/cs/oc/oms/invoice/changeInvoice', params),
  // 查看发票
  viewInvoice: params => network.post('/api/cs/oc/oms/invoice/view', params),
  // 新增发票
  saveApplyInvoice: params => network.post('/api/cs/oc/oms/invoice/saveApplyInvoice', params),
  // 平台单号查询
  queryTidFuzzy: params => network.post('/api/cs/oc/oms/invoice/queryTidFuzzy', params),
  // 平台单号校验
  checkParam: params => network.post('/api/cs/oc/oms/invoice/checkParam', params),
  newQueryList: params => network.post('/p/cs/newQueryList', params),
  // 月结汇总单- 月结汇总
  monthGather: params => network.post('/api/cs/ac/monthGather', params),
  settleBilShareAccAmt: params => network.post('/api/cs/ac/f/settleBilShareAccAmt', params),
  checkSettleBil: params => network.post('/api/cs/ac/f/checkSettleBil', params),
  delCfmBill: params => $network.post('/api/cs/ac/delCfmBill', params),
  consignmentStorageExport: params => $network.post('/api/cs/sg/consignmentStorage/export', params),
  acFSourceRefundExport: params => $network.post('/api/cs/ac/acFSourceRefund/export', params),
  acFSourceReturnExport: params => $network.post('/api/cs/ac/acFSourceReturn/export', params),
  acFSourceOrderExport: params => $network.post('/api/cs/ac/acFSourceOrder/export', params),
  cancelSettleBill: params => $network.post('/api/cs/ac/f/cancelSettleBill', params),
  manualSettle: params => $network.post('/api/cs/ac/f/manualSettle', params),
  reBill: params => $network.post('/api/cs/ac/f/reBill', params),
  delSettleBill: params => $network.post('/api/cs/ac/f/delSettleBill', params),
  downloadBillTemplate: (params) => network.get('/api/cs/ac/v1/commonBill/template/url', params), // 下载模板
  // 分销核价单
  queryOrderInfoAndSkuList: (params) => network.post('/api/cs/sg/v1/distribution/queryOrderInfoAndSkuList', params),
  saveSplitResult: (params) => network.post('/api/cs/sg/v1/distribution/saveSplitResult', params),
  saleOrderNoSendTransferItemExport: params => $network.post('/api/cs/rc/saleOrderNoSendTransferItem/export', params),
  storeDistributionExport: params => $network.post('/api/cs/sg/storeDistribution/export', params),
};
